import { render, staticRenderFns } from "./CardStatsV6.vue?vue&type=template&id=a1bcc6a8&scoped=true&"
import script from "./CardStatsV6.vue?vue&type=script&lang=js&"
export * from "./CardStatsV6.vue?vue&type=script&lang=js&"
import style0 from "./CardStatsV6.vue?vue&type=style&index=0&id=a1bcc6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bcc6a8",
  null
  
)

export default component.exports